<template>
  <div class="global-all">
    <div class="global-content">
      <div class="add-box">
        <a-form :form="form">
          <a-form-item>
            <div class="border-bottom-after">
              <a-input
                class="border-bottom"
                ref="enterpriseName"
                v-decorator="[
                  'enterpriseName',
                  {
                    rules: [
                      { required: true, message: '请输入企业全称' },
                      {
                        pattern: '^[\u4E00-\u9FA5A-Za-z0-9]+$',
                        message: '请输入中文,英文,数字',
                      },
                      { min: 1, max: 25, message: '最多输入25位' },
                    ],
                  },
                ]"
                placeholder="请输入企业全称"
                autocomplete="off"
              />
            </div>
          </a-form-item>
          <a-form-item>
            <div class="border-bottom">
              <!-- <a-input
                class="border-bottom transUpCase"
                ref="enterpriseCode"
                v-decorator="[
                  'enterpriseCode',
                  {
                    rules: [
                      { required: false, message: '请输入统一社会信用代码' },
                      {
                        pattern: '^[A-Za-z0-9]{18}$',
                        message: '请输入数字和字母的18位代码组合',
                      },
                    ],
                  },
                ]"
                placeholder="请输入统一社会信用代码"
                autocomplete="off"
              /> -->
            </div>
          </a-form-item>
          <a-form-item>
            <a-button type="default" class="my-btn" @click="save">
              确定
            </a-button>
            <a-button type="default" class="my-btn fr" @click="cancel">
              取消
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { addEnterprise, doubleCheck } from "../../api";

import { apiListPC } from "@/api";
import ajax from "@/api/ajax";

export default {
  name: "Add",
  data() {
    return {
      form: this.$form.createForm(this),
    };
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  methods: {
    save() {
      let that = this;
      this.form.validateFields((err) => {
        if (!err) {
          //在这里先进行ajax请求 把新的企业存进去 然后返回上一页面
          let sendData = {
            fullName: that.$refs.enterpriseName.value || "",
            creditCode: "",
          };
          ajax(apiListPC.doubleCheck, sendData).then((res) => {
            if (res.same) {
              that.$message.error(res.msg);
            } else {
              let formData = new FormData();
              formData.append("fullName", sendData.fullName);
              formData.append("creditCode", sendData.creditCode);

              let res = ajax(apiListPC.addEnterprise, formData, "POST");
              res
                .then(function () {
                  that.$message.success("新增成功！");
                  setTimeout(() => {
                    that.$router.back(-1);
                  }, 500);
                })
                .catch(function () {
                  that.$message.error("新增失败！");
                });
            }
          });
        }
      });
    },
    cancel() {
      this.$router.back(-1);
    },
  },
};
</script>

<style lang="less" type="text/less" scoped>
.global-all {
  background: url("../../../static/images/bg1.jpg") no-repeat;
  background-size: cover;
  padding-top: 20px;
  min-height: calc(100vh - 70px);

  .global-content {
    box-shadow: none;
    padding-top: 0px;

    .add-box {
      width: 500px;
      margin: 180px auto 0;

      .ant-input {
        height: 42px;
        line-height: 42px;
        font-size: 16px;
      }

      .border-bottom-after::before {
        content: "*";
        color: red;
        float: left;
        display: block;
        margin-left: -10px;
      }
      .my-btn {
        width: 45%;
        float: left;
        height: 42px;
        line-height: 42px;
        font-size: 16px;

        &:first-child {
          color: @primary-color;
        }
      }

      .fr {
        float: right;
      }
    }

    .transUpCase {
      text-transform: uppercase;
    }
  }
}
</style>
